export default __webpack_public_path__ + "08424fd52e54e99825d5d8cd7928fa66.png";